import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {environment} from '../../../environments/environment';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {HttpClient} from '@angular/common/http';
import {BaseClientComponent} from '../base-client.component';
import {SelectItem} from 'primeng/api';
import * as _ from 'lodash';
import {Continent} from '../../Enum/continent.enum';
import {ActivatedRoute} from '@angular/router';
import {LoaService} from '../../services/loa.service';
import {CustomUserService} from '../../services/custom-user.service';
import {XcoService} from '../../services/xco.service';
import {LoaFiltreCriteria} from '../../models/filter/loa-filter-criteria';
import {Company} from '../../models/company';
import {TechnicalPopService} from '../../services/technical-pop.service';

@Component({
  selector: 'app-loa',
  templateUrl: './loa.component.html',
  styleUrls: ['./loa.component.scss'],
  host: {class: 'sym-page'}
})
export class LoaComponent extends BaseClientComponent implements OnInit {

  @ViewChild('dataTableLoas') dataTableLoas: any;
  @ViewChild('contactsTable') contactsTable: any;
  listClients: Company[];
  contactsByContinentList: any[] = [];
  isMckayUser: boolean;
  serviceAbrvItems: SelectItem[];
  originalContactsByContinentList = [];
  mckayUserSelectedClient = false;
  editing = false;
  loaContactsResponse: any;
  selectedClientSugarUuid: any;
  selectedClient: Company;
  listClientsForClientDropDown: SelectItem[] = [];
  error = false;
  errorMessage = '';
  success = false;
  successMessages: string[] = [];
  acknowledgeDomainError = false;
  acknowledgeDomainErrorMessage = '';
  userChoicesFiltersDefaultLoa = {
    'serviceAbrv': 'MD/BW',
  };
  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultLoa);
  records = 0;
  cols = [
    {field: 'xcoId', header: 'CrossConnect ID', sortable: true},
    {field: 'loaStatus', header: 'Loa status', sortable: true},
    {field: 'mailRecipients', header: 'LOA email contacts', sortable: true},
    {field: 'pop', header: 'Data center', sortable: true},
    {field: 'contracts', header: 'Services/contracts', sortable: true},
    {field: 'rebillingStatus', header: 'Rebillable status', sortable: true},
    {field: 'loaHandoff', header: 'Hand off', sortable: true},
    {field: 'dataCenterRef', header: 'Datacenter ref', sortable: true},
    {field: 'clientRef', header: 'Customer ref', sortable: true}
  ];
  filteredXcoLoaList: any = [];
  xcoLoaList: any = [];
  globalFilter: any;
  loaFilterCriteria: LoaFiltreCriteria;
  loaUrl = environment.loaUrl;
  bwmUrl = environment.bwmUrl;
  mdmUrl = environment.mdmUrl;

  constructor(public authenticationService: AuthenticationService,
              private xcoService: XcoService,
              protected technicalPopService: TechnicalPopService,
              protected utilsService: UtilsService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private loaCustomService: LoaService,
              private cdr: ChangeDetectorRef,
              private customUserService: CustomUserService) {
    super();

    this.serviceAbrvItems = [
      {label: 'MD/BW', value: 'MD/BW'},
      {label: 'MD', value: 'MD'},
      {label: 'BW', value: 'BW'},
    ];
  }

  ngOnInit() {
    this.editing = false;
    this.loaFilterCriteria = new LoaFiltreCriteria(this.userChoicesActiveFilters);
    this.isMckayUser = this.authenticationService.getUserCurrent().permissions.isMckayUser;
    if (this.isMckayUser) {
      this.loadListClients();
      return;
    }
    this.selectedClientSugarUuid = this.authenticationService.userCurrent.company.sugarUuid;
    this.selectedClient = this.authenticationService.userCurrent.company;
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getXcoLoa(this.selectedClientSugarUuid);
      this.loadContactListForClient();
    });
    this.subscriptions.push(response$);

  }

  private getXcoLoa(clientUuid) {
    this.utilsService.lockUi();
    this.xcoService.getAllXcos(clientUuid).subscribe({
        next: res => {
          this.xcoLoaList = res;
          this.filteredXcoLoaList = res;
          this.records = res.length;
          this.xcoLoaList.forEach(xcoLoa => {
            if (xcoLoa.loaService === 'quincy') {
              xcoLoa.serviceAbrv = 'MD';
            } else if (xcoLoa.loaService === 'mckay') {
              xcoLoa.serviceAbrv = 'BW';
            } else {
              xcoLoa.serviceAbrv = '';
            }
            xcoLoa.textAriaRows = 1;
            xcoLoa.pop = '';
            if (xcoLoa.commercialPop !== null && xcoLoa.technicalPop !== null) {
              xcoLoa.pop = xcoLoa.commercialPop + '/' + xcoLoa.technicalPop;
            } else if (xcoLoa.commercialPop !== null) {
              xcoLoa.pop = xcoLoa.commercialPop;
            } else {
              xcoLoa.pop = xcoLoa.technicalPop;
            }
          });
          this.utilsService.unlockUi();
        }, error: error => {
          this.error = true;
          this.errorMessage = error.message;
          this.utilsService.unlockUi();
        }
      }
    );
  }

  loadContactListForMckayUser(company: Company) {
    const loaContactsUrl = environment.baseUrlWs + '/api/loa-contacts?company.sugarUuid=' + company.sugarUuid;
    this.loadLoaContactsList(loaContactsUrl);
  }

  loadContactListForClient() {
    const loaContactsUrl = environment.baseUrlWs + '/api/loa-contacts';
    this.loadLoaContactsList(loaContactsUrl);

  }

  loadListClients() {
    this.utilsService.lockUi();
    this.loaCustomService.loadClientList(this.authenticationService.userImpersonatedId).then(
      response => {
        this.listClients = response['member'].filter(client => !!client.sugarUuid && client.isActive);
        _.forEach(this.listClients, (client: Company) => {
          this.listClientsForClientDropDown.push({
            label: client.name,
            value: client.sugarUuid,
          });
        });
        this.route.paramMap.subscribe(params => {
          if (params.get('companySugarUuid')) {
            this.selectedClientSugarUuid = params.get('companySugarUuid');
            this.selectedClient = this.listClients.find(company => company.sugarUuid === this.selectedClientSugarUuid);
            this.loadClientsLoas();
          }
        });
        this.listClientsForClientDropDown = [...this.listClientsForClientDropDown].sort((a, b) => a.label.localeCompare(b.label));
        this.utilsService.unlockUi();
      }
    );
  }

  loadClientsLoas() {
    this.error = false;
    this.success = false;
    this.acknowledgeDomainError = false;
    this.xcoLoaList = null;
    this.mckayUserSelectedClient = true;
    const client = this.listClients.find(company => company.sugarUuid === this.selectedClientSugarUuid);
    if (client) {
      this.selectedClient = client;
      this.getXcoLoa(client.sugarUuid);
      this.loadContactListForMckayUser(client);
    }
  }


  showContactsTable() {
    return !this.isMckayUser || (this.mckayUserSelectedClient && this.originalContactsByContinentList);
  }

  checkEmailsValidity(contactsByContinent: any, serviceType: string) {
    this.success = false;
    this.successMessages = [];
    this.error = false;
    this.acknowledgeDomainError = false;
    const separatorPattern = /[,\s;]+/;
    const emailsBW = contactsByContinent.emailsBW.split(separatorPattern);
    const emailsMD = contactsByContinent.emailsMD.split(separatorPattern);
    if (serviceType === 'bw') {
      this.checkEmailValidity(contactsByContinent, emailsBW, serviceType);
    } else {
      this.checkEmailValidity(contactsByContinent, emailsMD, serviceType);
    }
  }

  onServiceEditCancel(contactsByContinent, serviceType) {
    const originalContacts = this.originalContactsByContinentList[contactsByContinent.continent];
    if (serviceType === 'bw') {
      contactsByContinent.emailsBW = originalContacts.filter(contact => contact.service === 'bw').map(contact => contact.email).join('; ');
    } else if (serviceType === 'md') {
      contactsByContinent.emailsMD = originalContacts.filter(contact => contact.service === 'md').map(contact => contact.email).join('; ');
    }
  }


  checkEmailValidity(contactsByContinent, newContactsArray, service) {
    const continent = contactsByContinent.continent;
    if (newContactsArray.length === 1 && newContactsArray[0] === '') {
      // case all the emails form a list have been deleted
      newContactsArray = [];
    }

    for (const email of newContactsArray) {
      if (!this.isValidEmail(email)) {
        this.error = true;
        this.errorMessage = 'Email must be a valid email address';
        this.onServiceEditCancel(contactsByContinent, service);
        return;
      }
    }

    // remove duplicated emails
    const existingEmails = new Set();
    const uniqueEmails = [];
    for (const email of newContactsArray) {
      const trimmed = email.trim();
      if (!existingEmails.has(trimmed)) {
        existingEmails.add(trimmed);
        uniqueEmails.push(trimmed);
      }
    }
    if (service === 'bw') {
      contactsByContinent.emailsBW = uniqueEmails.join('; ');
    } else if (service === 'md') {
      contactsByContinent.emailsMD = uniqueEmails.join('; ');
    }

    const originalContactsByService = this.originalContactsByContinentList[continent].filter(contact => contact.service === service);
    const originalContacts = originalContactsByService.map(item => item.email);

    const deletedContacts = originalContacts.filter(item => newContactsArray.indexOf(item) < 0);
    const addedContacts = uniqueEmails.filter(item => originalContacts.indexOf(item) < 0);
    if (deletedContacts.length === 0 && addedContacts.length === 0) {
      this.error = true;
      this.errorMessage = 'No update detected';
      return;
    }
    if (deletedContacts.length !== 0) {
      this.deleteRemovedContacts(deletedContacts, continent, service);
    }
    if (addedContacts.length !== 0) {
      this.addNewContacts(addedContacts, continent, service);
    }
  }


  hasSugarUuid(name) {
    this.listClients.filter(client => client.name === name);
    return this.listClients.length > 0;
  }

  private loadLoaContactsList(loaContactsUrl: string) {
    this.loaCustomService.loadLoaContactsList(loaContactsUrl, this.authenticationService.userCurrent.email)
      .subscribe(
        response => {
          this.loaContactsResponse = response;
          this.originalContactsByContinentList[Continent.AM] = response.filter(contact => contact.continent === Continent.AM);
          this.originalContactsByContinentList[Continent.EU] = response.filter(contact => contact.continent === Continent.EU);
          this.originalContactsByContinentList[Continent.AS] = response.filter(contact => contact.continent === Continent.AS);
          this.contactsByContinentList = [Continent.AM, Continent.EU, Continent.AS].map(continent => {
            const bwList = this.originalContactsByContinentList[continent].filter(c => c.service === 'bw').map(c => c.email);
            const mdList = this.originalContactsByContinentList[continent].filter(c => c.service === 'md').map(c => c.email);
            return {
              continent,
              emailsBW: bwList.join('; '),
              emailsMD: mdList.join('; '),
              emailsBWList: bwList,
              emailsMDList: mdList,
            };
          });
        }
      );
  }

  splitEmails(emails: string): string[] {
    return emails ? emails.split(';').map(e => e.trim()).filter(e => !!e) : [];
  }

  saveEmails(contactsByContinent: any, serviceType: string) {
    const list: string[] = serviceType === 'bw' ? (contactsByContinent.emailsBWList || []) : (contactsByContinent.emailsMDList || []);
    const lowered = list.map(e => e.toLowerCase().trim());
    if (lowered.length !== new Set(lowered).size) {
      this.error = true;
      this.successMessages = [];
      this.errorMessage = 'Duplicate email addresses are not allowed.';
      this.onServiceEditCancel(contactsByContinent, serviceType);
      if (serviceType === 'bw') {
        contactsByContinent.emailsBWList = this.splitEmails(contactsByContinent.emailsBW);
      } else {
        contactsByContinent.emailsMDList = this.splitEmails(contactsByContinent.emailsMD);
      }
      this.closeEditMode();
      return;
    }
    if (serviceType === 'bw') {
      contactsByContinent.emailsBW = list.join('; ');
    } else {
      contactsByContinent.emailsMD = list.join('; ');
    }
    this.checkEmailsValidity(contactsByContinent, serviceType);

    if (this.acknowledgeDomainError) {
      // Partial backend changes may have occurred (e.g. deletions succeeded).
      // Reload from the backend to reflect the true state instead of guessing.
      this.reloadContacts();
    } else if (this.error) {
      // No backend changes happened (format error or no update detected), so it is safe to revert locally.
      this.onServiceEditCancel(contactsByContinent, serviceType);
      if (serviceType === 'bw') {
        contactsByContinent.emailsBWList = this.splitEmails(contactsByContinent.emailsBW);
      } else {
        contactsByContinent.emailsMDList = this.splitEmails(contactsByContinent.emailsMD);
      }
    } else {
      if (serviceType === 'bw') {
        contactsByContinent.emailsBWList = this.splitEmails(contactsByContinent.emailsBW);
      } else {
        contactsByContinent.emailsMDList = this.splitEmails(contactsByContinent.emailsMD);
      }
    }
    this.closeEditMode();
  }

  private reloadContacts() {
    if (this.isMckayUser && this.selectedClient) {
      this.loadContactListForMckayUser(this.selectedClient);
    } else {
      this.loadContactListForClient();
    }
  }

  cancelEdit(contactsByContinent: any, serviceType: string) {
    this.onServiceEditCancel(contactsByContinent, serviceType);
    if (serviceType === 'bw') {
      contactsByContinent.emailsBWList = this.splitEmails(contactsByContinent.emailsBW);
    } else {
      contactsByContinent.emailsMDList = this.splitEmails(contactsByContinent.emailsMD);
    }
    this.closeEditMode();
  }

  private closeEditMode() {
    if (this.contactsTable?.editingCell) {
      this.contactsTable.editingCell = null;
      this.cdr.detectChanges();
    }
  }

  private deleteRemovedContacts(deletedContacts, continent, service) {
    for (const deletedContact of deletedContacts) {
      if (!deletedContact || deletedContact === '') {
        continue;
      }
      let deletedContactId = 0;
      deletedContactId = this.loaContactsResponse
        .filter(contact => contact.email === deletedContact && contact.continent === continent && contact.service === service)
        .map(contact => contact.id);
      this.loaCustomService.deleteLoaContact(deletedContactId).subscribe(
        () => {
          this.success = true;
          this.successMessages.push(`${deletedContact} was successfully removed.`);
          this.reloadContacts();
        }
      );
    }
  }

  private addNewContacts(addedContacts, continent, service) {
    for (const newContact of addedContacts) {
      if (newContact === '') {
        continue;
      }
      const domain = this.customUserService.getEmailDomain(newContact.toLowerCase());
      if (this.selectedClient.acknowledgeDomains.indexOf(domain) === -1) {
        this.success = false;
        this.acknowledgeDomainError = true;
        this.acknowledgeDomainErrorMessage = `${newContact} is not from a registered company domain.`;
        continue;
      }
      const loaContact = {
        'service': service,
        'email': newContact,
        'continent': continent,
        'company': this.selectedClientSugarUuid
      };
      this.loaCustomService.addLoaContact(loaContact).subscribe(
        () => {
          this.acknowledgeDomainError = false;
          this.success = true;
          this.successMessages.push(`${newContact} was successfully added.`);
          this.reloadContacts();
        }
      );
    }
  }

  changeClientRef(xco: any) {
    xco.textAriaRows = 1;
    if (xco.newClientRef === xco.clientRef) {
      return;
    }
    this.xcoService.changeClientRef(xco.id, xco.newClientRef).subscribe(
      () => {
        this.success = true;
        this.successMessages = ['Customer ref has been updated.'];
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        xco.clientRef = xco.newClientRef;
      }
    );
  }

  get csvFilename() {
    return 'Cross-Connect';
  }

  filter() {
    this.filteredXcoLoaList = [];
    if (this.xcoLoaList) {
      this.utilsService.saveUserData('loaFilter',
        {
          'serviceAbrv': this.loaFilterCriteria.serviceAbrv,
        });
      this.xcoLoaList.forEach(xcoLoa => {
        if (this.loaFilterCriteria.serviceAbrv === 'MD/BW') {
          this.filteredXcoLoaList.push(xcoLoa);
        } else if (this.isSelected(xcoLoa)) {
          this.filteredXcoLoaList.push(xcoLoa);
        }
      });
      this.records = this.filteredXcoLoaList.length;
    }
  }

  applyFiltersOnDataTableItem() {
    this.dataTableLoas.filterGlobal(this.globalFilter, 'contains');
  }

  resetFilters() {
    this.globalFilter = null;
    this.dataTableLoas.filterGlobal('', 'contains');
    this.loaFilterCriteria.serviceAbrv = this.userChoicesFiltersDefaultLoa.serviceAbrv;
    this.filter();
  }

  isSelected(loa): boolean {
    return this.loaFilterCriteria.serviceAbrv === loa.serviceAbrv || this.loaFilterCriteria.serviceAbrv === '';
  }

  isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  exportToCsv() {
    const updatedData = [];
    for (let i = 0; i < this.filteredXcoLoaList.length; i++) {
      const xcoLoa = this.filteredXcoLoaList[i];
      let contractNames = '';
      for (let j = 0; j < xcoLoa.contracts.length; j++) {
        contractNames += xcoLoa.contracts[j].name;
        if (j < xcoLoa.contracts.length - 1) {
          contractNames += ', ';
        }
      }
      updatedData.push({
        ...xcoLoa,
        cageNames: this.technicalPopService.getCageName(xcoLoa.technicalPop) || '',
        loaStatus: xcoLoa.loaStatus === 'Sent' ? `Sent ${xcoLoa.loaSentDate}` : xcoLoa.loaStatus || '',
        contracts: contractNames
      });
    }
    const originalData = this.dataTableLoas.value;
    const originalColumns = this.dataTableLoas.columns;
    const exportColumns = [...this.cols];
    const dataCenterIndex = exportColumns.findIndex(col => col.field === 'pop');
    exportColumns.splice(dataCenterIndex + 1, 0,
      {field: 'cageNames', header: 'Cages', sortable: false});
    this.dataTableLoas.value = updatedData;
    this.dataTableLoas.columns = exportColumns;
    this.dataTableLoas.exportCSV();
    this.dataTableLoas.value = originalData;
    this.dataTableLoas.columns = originalColumns;
  }


  getProjectLink(contract: any) {
    if (contract.type === 'OF' ) {
      // redirect to mdm
      return this.mdmUrl + '/#/orderForm-Edit/' + contract.uuid ;
    } else  if (contract.type === 'BWschedule') {
      // redirect to bwm
      return this.bwmUrl + '/#/schedule-edit/' + contract.id ;
    } else {
      return '';
    }
  }

  isOnlyFinanceUser(): boolean {
    const currentUser = this.authenticationService.getUserCurrent();
    const roles = currentUser.roles;
    if (roles.length === 3 && roles.includes('ROLE_MCKAY_FINANCE') && roles.includes('ROLE_USER') && roles.includes('ROLE_MCKAY')) {
      return true;
    }
    return roles.length === 3 && roles.includes('ROLE_CLIENT_FINANCE') && roles.includes('ROLE_USER') && roles.includes('ROLE_CLIENT');

  }
}
